import React, { memo, useMemo } from "react";
import { withNamespaces } from "react-i18next";
import DonutChart from "src/modules/data-protection/pages/admin/dashboard/components/ApexChart/DonutChart";
import {
    AI_TASK_STATUS_COLOR,
    AI_TASK_STATUS_ORDER,
} from "../ai-risk-chart-constants";

const MitigationTasks = memo(({ t, data, isFetching }) => {
    const byStatus = Array.isArray(data?.byStatus) ? data.byStatus : [];
    const byStatusMap = useMemo(
        () => Object.fromEntries(byStatus.map((row) => [row.status, row])),
        [byStatus]
    );
    const categories = useMemo(
        () =>
            AI_TASK_STATUS_ORDER.map((status) => {
                const row = byStatusMap[status];
                const amount = Number(row?.amount) || 0;
                const percent = Number(row?.percent) || 0;
                return {
                    title:
                        status === "IN_PROGRESS"
                            ? "In Progress"
                            : status.charAt(0) + status.slice(1).toLowerCase(),
                    amount,
                    percent,
                    status,
                };
            }),
        [byStatusMap]
    );
    const colors = useMemo(
        () => categories.map((row) => AI_TASK_STATUS_COLOR[row.status] || "#90A4AE"),
        [categories]
    );

    if (isFetching) {
        return <div className="dt-field dt-skeleton mb-3" style={{ width: "100%", height: "460px" }} />;
    }

    return (
        <DonutChart
            title={t("Mitigation Tasks")}
            categories={categories}
            colors={colors}
            cardStyle={{ height: "460px" }}
            bodyStyle={{ height: "100%" }}
        />
    );
});

export default withNamespaces()(MitigationTasks);
